import { configureStore, combineReducers } from "@reduxjs/toolkit";
import apiDataBridge from "./api";
import apiLogin from "./api/apiLogin";
import rtkQueryErrorLogger from "./rtkQueryErrorLogger";
import { authSlice } from "@auth/store";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const root = combineReducers({
    [apiDataBridge.reducerPath]: apiDataBridge.reducer,
    [apiLogin.reducerPath]: apiLogin.reducer,
    [authSlice.name]: authSlice.reducer
});

const createStore = configureStore({
    reducer: root,
    middleware: (getDefaults) => getDefaults().concat(apiDataBridge.middleware).concat(rtkQueryErrorLogger).concat(apiLogin.middleware)
})

export type RootState = ReturnType<typeof root>
export type AppDispatch = typeof createStore.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const  useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default createStore;